"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceAndConditionOutput = exports.MarginOutput = exports.DriverPriceAndConditionData = exports.PassengerPriceAndConditionData = exports.PriceAndConditionData = exports.DriverConditionDetailsOutput = exports.DriverConditionOutput = exports.PassengerConditionDetails = exports.DriverPriceDetailsOutput = exports.DriverPriceOutput = exports.PassengerPriceDetails = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const price_output_1 = require("../../commons/output/price.output");
class PassengerPriceDetails {
}
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerPriceDetails.prototype, "priceWithoutOptions", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerPriceDetails.prototype, "price", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerPriceDetails.prototype, "extraApproachPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerPriceDetails.prototype, "markup", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerPriceDetails.prototype, "customerRemuneration", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerPriceDetails.prototype, "toll", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerPriceDetails.prototype, "allocabCommissionForTaxi", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerPriceDetails.prototype, "boosterSeat", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerPriceDetails.prototype, "childSeat", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerPriceDetails.prototype, "promoCode", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerPriceDetails.prototype, "reception", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerPriceDetails.prototype, "passengerLate", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerPriceDetails.prototype, "driverLate", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PassengerPriceDetails.prototype, "calculationWithVars", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PassengerPriceDetails.prototype, "calculation", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)(['LINK', 'DISTANCE']),
    __metadata("design:type", String)
], PassengerPriceDetails.prototype, "calculationMode", void 0);
exports.PassengerPriceDetails = PassengerPriceDetails;
class DriverPriceOutput {
}
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], DriverPriceOutput.prototype, "priceWithoutOptions", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], DriverPriceOutput.prototype, "price", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], DriverPriceOutput.prototype, "extraApproachPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], DriverPriceOutput.prototype, "toll", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], DriverPriceOutput.prototype, "boosterSeat", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], DriverPriceOutput.prototype, "childSeat", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], DriverPriceOutput.prototype, "reception", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], DriverPriceOutput.prototype, "passengerLate", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], DriverPriceOutput.prototype, "driverLate", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], DriverPriceOutput.prototype, "customerRemuneration", void 0);
exports.DriverPriceOutput = DriverPriceOutput;
class DriverPriceDetailsOutput {
}
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DriverPriceOutput),
    __metadata("design:type", DriverPriceOutput)
], DriverPriceDetailsOutput.prototype, "brut", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DriverPriceOutput),
    __metadata("design:type", DriverPriceOutput)
], DriverPriceDetailsOutput.prototype, "netForDriverWithTax", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DriverPriceOutput),
    __metadata("design:type", DriverPriceOutput)
], DriverPriceDetailsOutput.prototype, "netForDriverWithoutTax", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], DriverPriceDetailsOutput.prototype, "appliedSubscriptionPrice", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DriverPriceDetailsOutput.prototype, "calculationWithVars", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DriverPriceDetailsOutput.prototype, "calculation", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)(['LINK', 'DISTANCE']),
    __metadata("design:type", String)
], DriverPriceDetailsOutput.prototype, "calculationMode", void 0);
exports.DriverPriceDetailsOutput = DriverPriceDetailsOutput;
class PassengerConditionDetails {
}
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerConditionDetails.prototype, "linkPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerConditionDetails.prototype, "basePrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerConditionDetails.prototype, "extraApproachPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerConditionDetails.prototype, "minimumPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerConditionDetails.prototype, "pricePerKm", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerConditionDetails.prototype, "pricePerMin", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], PassengerConditionDetails.prototype, "surge", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerConditionDetails.prototype, "noShowPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerConditionDetails.prototype, "lateCancellationPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], PassengerConditionDetails.prototype, "waitingMinutePrice", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], PassengerConditionDetails.prototype, "freeWaitingMinutes", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], PassengerConditionDetails.prototype, "timeToWaitBeforeNoShow", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], PassengerConditionDetails.prototype, "freeCancellationPeriodAfterBooking", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], PassengerConditionDetails.prototype, "freeCancellationPeriodBeforeTrip", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], PassengerConditionDetails.prototype, "freeWaitingMinutesBillableForNoShow", void 0);
exports.PassengerConditionDetails = PassengerConditionDetails;
class DriverConditionOutput {
}
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], DriverConditionOutput.prototype, "linkPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], DriverConditionOutput.prototype, "basePrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], DriverConditionOutput.prototype, "extraApproachPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], DriverConditionOutput.prototype, "minimumPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], DriverConditionOutput.prototype, "pricePerKm", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], DriverConditionOutput.prototype, "pricePerMin", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], DriverConditionOutput.prototype, "noShowPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], DriverConditionOutput.prototype, "lateCancellationPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], DriverConditionOutput.prototype, "waitingMinutePrice", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DriverConditionOutput.prototype, "commissionRate", void 0);
exports.DriverConditionOutput = DriverConditionOutput;
class DriverConditionDetailsOutput {
}
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DriverConditionOutput),
    __metadata("design:type", DriverConditionOutput)
], DriverConditionDetailsOutput.prototype, "brut", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DriverConditionOutput),
    __metadata("design:type", DriverConditionOutput)
], DriverConditionDetailsOutput.prototype, "netForDriverWithTax", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DriverConditionOutput),
    __metadata("design:type", DriverConditionOutput)
], DriverConditionDetailsOutput.prototype, "netForDriverWithoutTax", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DriverConditionDetailsOutput.prototype, "surge", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], DriverConditionDetailsOutput.prototype, "subscriptionPrice", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DriverConditionDetailsOutput.prototype, "freeWaitingMinutes", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DriverConditionDetailsOutput.prototype, "timeToWaitBeforeNoShow", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DriverConditionDetailsOutput.prototype, "freeCancellationPeriodAfterBooking", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DriverConditionDetailsOutput.prototype, "freeCancellationPeriodBeforeTrip", void 0);
exports.DriverConditionDetailsOutput = DriverConditionDetailsOutput;
class PriceAndConditionData {
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], PriceAndConditionData.prototype, "priceGridKey", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], PriceAndConditionData.prototype, "priceGridName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PriceAndConditionData.prototype, "priceConditionKey", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PriceAndConditionData.prototype, "priceConditionName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], PriceAndConditionData.prototype, "hourlyRateKey", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], PriceAndConditionData.prototype, "hourlyRateName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], PriceAndConditionData.prototype, "linkPriceKey", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], PriceAndConditionData.prototype, "linkName", void 0);
exports.PriceAndConditionData = PriceAndConditionData;
class PassengerPriceAndConditionData extends PriceAndConditionData {
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], PassengerPriceAndConditionData.prototype, "proAccountConditionKey", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PassengerPriceDetails),
    __metadata("design:type", PassengerPriceDetails)
], PassengerPriceAndConditionData.prototype, "priceDetails", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PassengerConditionDetails),
    __metadata("design:type", PassengerConditionDetails)
], PassengerPriceAndConditionData.prototype, "conditionDetails", void 0);
exports.PassengerPriceAndConditionData = PassengerPriceAndConditionData;
class DriverPriceAndConditionData extends PriceAndConditionData {
}
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DriverPriceDetailsOutput),
    __metadata("design:type", DriverPriceDetailsOutput)
], DriverPriceAndConditionData.prototype, "priceDetails", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DriverConditionDetailsOutput),
    __metadata("design:type", DriverConditionDetailsOutput)
], DriverPriceAndConditionData.prototype, "conditionDetails", void 0);
exports.DriverPriceAndConditionData = DriverPriceAndConditionData;
class MarginOutput {
}
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], MarginOutput.prototype, "finalSellPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], MarginOutput.prototype, "finalBuyPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], MarginOutput.prototype, "netDriverPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], MarginOutput.prototype, "outsourcing", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], MarginOutput.prototype, "dedicatedPackagePrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], MarginOutput.prototype, "rfaPrice", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], MarginOutput.prototype, "rfaRate", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], MarginOutput.prototype, "additionalFeesPrice", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], MarginOutput.prototype, "additionalFeesRate", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], MarginOutput.prototype, "brutMarginRate", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], MarginOutput.prototype, "brutMargin", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], MarginOutput.prototype, "buySellGap", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], MarginOutput.prototype, "buySellGapRate", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], MarginOutput.prototype, "markup", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], MarginOutput.prototype, "markupRate", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], MarginOutput.prototype, "customerRemuneration", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], MarginOutput.prototype, "customerRemunerationRate", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], MarginOutput.prototype, "subscription", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], MarginOutput.prototype, "finalMargin", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], MarginOutput.prototype, "finalMarginRate", void 0);
exports.MarginOutput = MarginOutput;
class PriceAndConditionOutput {
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PriceAndConditionOutput.prototype, "key", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], PriceAndConditionOutput.prototype, "tripKey", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], PriceAndConditionOutput.prototype, "bookingKey", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PriceAndConditionOutput.prototype, "panelKey", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PassengerPriceAndConditionData),
    __metadata("design:type", PassengerPriceAndConditionData)
], PriceAndConditionOutput.prototype, "passenger", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DriverPriceAndConditionData),
    __metadata("design:type", DriverPriceAndConditionData)
], PriceAndConditionOutput.prototype, "driver", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => MarginOutput),
    __metadata("design:type", MarginOutput)
], PriceAndConditionOutput.prototype, "margin", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], PriceAndConditionOutput.prototype, "createdAt", void 0);
exports.PriceAndConditionOutput = PriceAndConditionOutput;
